import type { DatabaseEngineId } from '@/core/engines';

const LABELS: Record<DatabaseEngineId, string> = {
  mssql: 'SQL Server',
  pgsql: 'PostgreSQL',
  mysql: 'MySQL',
  oracle: 'Oracle',
  sqlite: 'SQLite',
  kusto: 'Azure Data Explorer',
  azurestorage: 'Azure Storage',
  mock: 'Mock',
};

export function getEngineLabel(engine: DatabaseEngineId): string {
  return LABELS[engine];
}
